var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-wiki-nav"},[_c('Menu',{staticClass:"c-wiki-menu"}),_c('div',{staticClass:"c-nav-content"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }